import { LoaderCircle, LucideProps } from 'lucide-react';
import { cn } from '@lib/utils/ui';
export interface IProps extends LucideProps {
  className?: string;
}
export const LoadingSpinner = ({
  className,
  ...props
}: IProps) => {
  return <LoaderCircle className={cn('animate-spin', className)} {...props} data-sentry-element="LoaderCircle" data-sentry-component="LoadingSpinner" data-sentry-source-file="loading-spinner.tsx" />;
};